import { render, staticRenderFns } from "./Anniversary.vue?vue&type=template&id=31077bd6&scoped=true"
import script from "./Anniversary.vue?vue&type=script&lang=js"
export * from "./Anniversary.vue?vue&type=script&lang=js"
import style0 from "./Anniversary.vue?vue&type=style&index=0&id=31077bd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31077bd6",
  null
  
)

export default component.exports